// Textos do Vale-alimentação (26/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.vale.titulo': 'Vale-alimentação',
    'dp.vale.eyebrow': 'Departamento Pessoal',
    'dp.vale.apurar': 'Apurar',
    'dp.vale.reapurar': 'Reapurar',
    'dp.vale.apurada': 'Apuração feita: {{novas}} novas, {{recalculadas}} recalculadas.',
    'dp.vale.naoApurada': 'A competência {{rotulo}} ainda não foi apurada. Apurar junta a diária do Protheus, as Gestões de suspensão e a assinatura do espelho de {{espelho}}, e aplica as regras da planilha do DP.',
    'dp.vale.explica': 'Cesta básica da cláusula 32 do acordo coletivo, {{valor}} por mês para motoristas e operadores. Corta quem não assinou o espelho de {{espelho}} até {{prazo}}, quem faltou sem justificativa e quem foi suspenso; afastamento acima de {{vaZeraAcima}} dias zera o mês.',
    'dp.vale.antesDoPrazo': 'Até {{prazo}}, quem ainda não assinou o espelho de {{espelho}} aparece cortado. Reapure depois do prazo.',
    'dp.vale.kpi.total': 'Total a pagar',
    'dp.vale.kpi.pessoas': 'Pessoas',
    'dp.vale.kpi.cortadas': 'Cortadas',
    'dp.vale.kpi.pendencias': 'Pendências do mês anterior',
    'dp.vale.kpi.ajustes': 'Ajustes manuais',
    'dp.vale.porFilial': 'Por filial',
    'dp.vale.cortesPorMotivo': 'Cortes por motivo',
    'dp.vale.col.pessoa': 'Pessoa',
    'dp.vale.col.cortes': 'Cortes',
    'dp.vale.col.pendencia': 'Mês anterior',
    'dp.vale.col.valor': 'Valor',
    'dp.vale.col.acoes': 'Ações',
    'dp.vale.dias': '{{considerados}} de {{periodo}} dias',
    'dp.vale.afastado': '{{dias}} dias afastado',
    'dp.vale.semCorte': 'Sem corte',
    'dp.vale.espelhoLegenda.assinado_no_prazo': 'Espelho assinado no prazo',
    'dp.vale.espelhoLegenda.isento': 'Isento do espelho',
    'dp.vale.espelhoLegenda.sem': 'Sem registro no espelho',
    'dp.vale.pendenciaSugerida': 'Sugerida',
    'dp.vale.pendenciaConfirmada': 'Confirmada',
    'dp.vale.pendenciaConfirmar': 'Confirmar pendência',
    'dp.vale.calculado': 'Calculado {{valor}}',
    'dp.vale.retroativo': 'Mês anterior {{valor}}',
    'dp.vale.ajustado': 'Ajustado',
    'dp.vale.ajustar': 'Ajustar',
    'dp.vale.memoria': 'Cálculo',
    'dp.vale.ajusteTitulo': 'Ajuste de {{nome}}',
    'dp.vale.ajusteValor': 'Valor a pagar',
    'dp.vale.ajusteJustificativa': 'Justificativa',
    'dp.vale.ajusteExplica': 'O valor ajustado substitui o calculado e sobrevive à reapuração. Deixe em branco para voltar ao calculado.',
    'dp.vale.ajusteSalvar': 'Salvar ajuste',
    'dp.vale.memoriaTitulo': 'Cálculo de {{nome}}',
    'dp.vale.memoria.periodo': 'Período',
    'dp.vale.memoria.vinculo': 'Vínculo no período',
    'dp.vale.memoria.afastamento': 'Dias afastado',
    'dp.vale.memoria.considerados': 'Dias considerados',
    'dp.vale.memoria.conta': 'Conta',
    'dp.vale.memoria.fontes': 'Fontes',
    'dp.vale.memoria.diaria': 'Diária do Protheus no período',
    'dp.vale.memoria.gestao': 'Suspensão aplicada em Gestões',
    'dp.vale.memoria.jornada': 'Gestões de jornada',
    'dp.vale.memoria.sim': 'Sim',
    'dp.vale.memoria.nao': 'Não',
    'dp.vale.corte.ponto_nao_assinado': 'Espelho não assinado',
    'dp.vale.corte.ponto_fora_do_prazo': 'Espelho fora do prazo',
    'dp.vale.corte.falta_injustificada': 'Falta',
    'dp.vale.corte.suspensao': 'Suspensão',
    'dp.vale.corte.afastamento_acima_do_limite': 'Afastamento acima de {{vaZeraAcima}} dias',
    'dp.vale.corte.jornada': 'Gestão de jornada',
    'dp.vale.picpay': 'PicPay',
    'dp.vale.picpayDica': 'O arquivo de carga do PicPay de cada filial, com quem tem valor a receber',
    'dp.vale.semEspelho': 'O espelho de {{espelho}} não está no Hub, então ninguém foi cortado pelo ponto. Importe a planilha de controle ou abra a competência na Assinatura do ponto e reapure.',
    'dp.vale.assinatura.assinado_no_prazo': 'Assinou no prazo',
    'dp.vale.assinatura.assinado_fora_do_prazo': 'Assinou fora do prazo',
    'dp.vale.assinatura.pendente': 'Não assinou',
    'dp.vale.assinatura.isento': 'Isento',
    'dp.vale.assinatura.sem': 'Sem registro',
    'dp.vale.fonte.ponto_nao_assinado': 'Vem da Assinatura do ponto',
    'dp.vale.fonte.ponto_fora_do_prazo': 'Vem da Assinatura do ponto',
    'dp.vale.fonte.falta_injustificada': 'Vem da diária do Protheus',
    'dp.vale.fonte.suspensao': 'Vem da diária do Protheus ou de uma Gestão de suspensão aplicada',
    'dp.vale.fonte.afastamento_acima_do_limite': 'Vem da diária do Protheus, {{dias}} dias afastado',
    'dp.vale.pendenciaPagar': 'Pagar a pendência do mês anterior',
    'dp.vale.pendenciaExplica': 'Soma um mês cheio, {{valor}}, para quem foi cortado pelo ponto na competência anterior e assinou depois.',
    'dp.vale.pendenciaSugeridaAviso': 'O Hub sugere a pendência: a pessoa foi cortada pelo ponto na competência anterior e o espelho foi assinado depois.',
    'dp.vale.memoria.diasN': '{{n}} dias',
    'dp.vale.memoria.limite': 'Zera acima de {{n}} dias',
    'dp.vale.memoria.espelho': 'Espelho de {{rotulo}}',
    'dp.vale.memoria.cortado': 'Cortado, o mês fica zerado',
    'dp.vale.memoria.retroativo': 'Pendência do mês anterior',
    'dp.vale.memoria.ajuste': 'Ajuste manual',
    'dp.vale.memoria.final': 'Valor final',
    'dp.vale.memoria.semDiaria': 'Nenhuma diária no período',
    'dp.vale.memoria.cortes': 'Cortes',
    'dp.vale.admitidoEm': 'Admitido em {{data}}',
    'dp.vale.desligadoEm': 'Desligado em {{data}}',
    'dp.vale.kpi.pendenciasDica': '{{confirmadas}} confirmadas e {{sugeridas}} sugeridas pelo Hub',
    'dp.vale.pessoasN': '{{n}} pessoas',
  },
  en: {
    'dp.vale.titulo': 'Meal allowance',
    'dp.vale.eyebrow': 'Personnel Department',
    'dp.vale.apurar': 'Calculate',
    'dp.vale.reapurar': 'Recalculate',
    'dp.vale.apurada': 'Calculated: {{novas}} new, {{recalculadas}} recalculated.',
    'dp.vale.naoApurada': 'The {{rotulo}} pay period has not been calculated yet. Calculating gathers the Protheus daily records, the suspension Warnings and the {{espelho}} timesheet signatures, and applies the department spreadsheet rules.',
    'dp.vale.explica': 'Food basket from clause 32 of the collective agreement, {{valor}} a month for drivers and operators. It is cut for whoever did not sign the {{espelho}} timesheet by {{prazo}}, had an unjustified absence or was suspended; more than {{vaZeraAcima}} days on leave zeroes the month.',
    'dp.vale.antesDoPrazo': 'Until {{prazo}}, whoever has not signed the {{espelho}} timesheet shows as cut. Recalculate after the deadline.',
    'dp.vale.kpi.total': 'Total to pay',
    'dp.vale.kpi.pessoas': 'People',
    'dp.vale.kpi.cortadas': 'Cut',
    'dp.vale.kpi.pendencias': 'Previous month pending',
    'dp.vale.kpi.ajustes': 'Manual adjustments',
    'dp.vale.porFilial': 'By branch',
    'dp.vale.cortesPorMotivo': 'Cuts by reason',
    'dp.vale.col.pessoa': 'Person',
    'dp.vale.col.cortes': 'Cuts',
    'dp.vale.col.pendencia': 'Previous month',
    'dp.vale.col.valor': 'Amount',
    'dp.vale.col.acoes': 'Actions',
    'dp.vale.dias': '{{considerados}} of {{periodo}} days',
    'dp.vale.afastado': '{{dias}} days on leave',
    'dp.vale.semCorte': 'No cut',
    'dp.vale.espelhoLegenda.assinado_no_prazo': 'Timesheet signed on time',
    'dp.vale.espelhoLegenda.isento': 'Exempt from the timesheet',
    'dp.vale.espelhoLegenda.sem': 'No timesheet record',
    'dp.vale.pendenciaSugerida': 'Suggested',
    'dp.vale.pendenciaConfirmada': 'Confirmed',
    'dp.vale.pendenciaConfirmar': 'Confirm pending month',
    'dp.vale.calculado': 'Calculated {{valor}}',
    'dp.vale.retroativo': 'Previous month {{valor}}',
    'dp.vale.ajustado': 'Adjusted',
    'dp.vale.ajustar': 'Adjust',
    'dp.vale.memoria': 'Calculation',
    'dp.vale.ajusteTitulo': 'Adjustment for {{nome}}',
    'dp.vale.ajusteValor': 'Amount to pay',
    'dp.vale.ajusteJustificativa': 'Reason',
    'dp.vale.ajusteExplica': 'The adjusted amount replaces the calculated one and survives recalculation. Leave it empty to go back to the calculated amount.',
    'dp.vale.ajusteSalvar': 'Save adjustment',
    'dp.vale.memoriaTitulo': 'Calculation for {{nome}}',
    'dp.vale.memoria.periodo': 'Period',
    'dp.vale.memoria.vinculo': 'Employed in the period',
    'dp.vale.memoria.afastamento': 'Days on leave',
    'dp.vale.memoria.considerados': 'Days counted',
    'dp.vale.memoria.conta': 'Math',
    'dp.vale.memoria.fontes': 'Sources',
    'dp.vale.memoria.diaria': 'Protheus daily records in the period',
    'dp.vale.memoria.gestao': 'Suspension applied in Warnings',
    'dp.vale.memoria.jornada': 'Working-hours warnings',
    'dp.vale.memoria.sim': 'Yes',
    'dp.vale.memoria.nao': 'No',
    'dp.vale.corte.ponto_nao_assinado': 'Timesheet not signed',
    'dp.vale.corte.ponto_fora_do_prazo': 'Timesheet signed late',
    'dp.vale.corte.falta_injustificada': 'Absence',
    'dp.vale.corte.suspensao': 'Suspension',
    'dp.vale.corte.afastamento_acima_do_limite': 'Leave over {{vaZeraAcima}} days',
    'dp.vale.corte.jornada': 'Working-hours warning',
    'dp.vale.picpay': 'PicPay',
    'dp.vale.picpayDica': 'The PicPay load file for each branch, with everyone who has an amount to receive',
    'dp.vale.semEspelho': 'The {{espelho}} timesheet is not in the Hub, so nobody was cut for the timesheet. Import the control spreadsheet or open the pay period in Timesheet signature and recalculate.',
    'dp.vale.assinatura.assinado_no_prazo': 'Signed on time',
    'dp.vale.assinatura.assinado_fora_do_prazo': 'Signed late',
    'dp.vale.assinatura.pendente': 'Not signed',
    'dp.vale.assinatura.isento': 'Exempt',
    'dp.vale.assinatura.sem': 'No record',
    'dp.vale.fonte.ponto_nao_assinado': 'From Timesheet signature',
    'dp.vale.fonte.ponto_fora_do_prazo': 'From Timesheet signature',
    'dp.vale.fonte.falta_injustificada': 'From the Protheus daily record',
    'dp.vale.fonte.suspensao': 'From the Protheus daily record or an applied suspension Warning',
    'dp.vale.fonte.afastamento_acima_do_limite': 'From the Protheus daily record, {{dias}} days on leave',
    'dp.vale.pendenciaPagar': 'Pay the previous month pending amount',
    'dp.vale.pendenciaExplica': 'Adds one full month, {{valor}}, for whoever was cut for the timesheet in the previous pay period and signed afterwards.',
    'dp.vale.pendenciaSugeridaAviso': 'The Hub suggests a pending month: this person was cut for the timesheet in the previous pay period and signed afterwards.',
    'dp.vale.memoria.diasN': '{{n}} days',
    'dp.vale.memoria.limite': 'Zeroed above {{n}} days',
    'dp.vale.memoria.espelho': '{{rotulo}} timesheet',
    'dp.vale.memoria.cortado': 'Cut, the month is zeroed',
    'dp.vale.memoria.retroativo': 'Previous month pending amount',
    'dp.vale.memoria.ajuste': 'Manual adjustment',
    'dp.vale.memoria.final': 'Final amount',
    'dp.vale.memoria.semDiaria': 'No daily records in the period',
    'dp.vale.memoria.cortes': 'Cuts',
    'dp.vale.admitidoEm': 'Hired on {{data}}',
    'dp.vale.desligadoEm': 'Dismissed on {{data}}',
    'dp.vale.kpi.pendenciasDica': '{{confirmadas}} confirmed and {{sugeridas}} suggested by the Hub',
    'dp.vale.pessoasN': '{{n}} people',
  },
  es: {
    'dp.vale.titulo': 'Vale de alimentación',
    'dp.vale.eyebrow': 'Departamento de Personal',
    'dp.vale.apurar': 'Calcular',
    'dp.vale.reapurar': 'Recalcular',
    'dp.vale.apurada': 'Cálculo hecho: {{novas}} nuevas, {{recalculadas}} recalculadas.',
    'dp.vale.naoApurada': 'El período {{rotulo}} aún no fue calculado. Calcular reúne la diaria de Protheus, las Gestiones de suspensión y la firma de la hoja de {{espelho}}, y aplica las reglas de la planilla del departamento.',
    'dp.vale.explica': 'Canasta básica de la cláusula 32 del acuerdo colectivo, {{valor}} por mes para conductores y operadores. Se corta a quien no firmó la hoja de {{espelho}} hasta el {{prazo}}, faltó sin justificación o fue suspendido; licencia de más de {{vaZeraAcima}} días anula el mes.',
    'dp.vale.antesDoPrazo': 'Hasta el {{prazo}}, quien aún no firmó la hoja de {{espelho}} aparece cortado. Recalcule después del plazo.',
    'dp.vale.kpi.total': 'Total a pagar',
    'dp.vale.kpi.pessoas': 'Personas',
    'dp.vale.kpi.cortadas': 'Cortadas',
    'dp.vale.kpi.pendencias': 'Pendientes del mes anterior',
    'dp.vale.kpi.ajustes': 'Ajustes manuales',
    'dp.vale.porFilial': 'Por sucursal',
    'dp.vale.cortesPorMotivo': 'Cortes por motivo',
    'dp.vale.col.pessoa': 'Persona',
    'dp.vale.col.cortes': 'Cortes',
    'dp.vale.col.pendencia': 'Mes anterior',
    'dp.vale.col.valor': 'Valor',
    'dp.vale.col.acoes': 'Acciones',
    'dp.vale.dias': '{{considerados}} de {{periodo}} días',
    'dp.vale.afastado': '{{dias}} días con licencia',
    'dp.vale.semCorte': 'Sin corte',
    'dp.vale.espelhoLegenda.assinado_no_prazo': 'Hoja firmada en plazo',
    'dp.vale.espelhoLegenda.isento': 'Exento de la hoja',
    'dp.vale.espelhoLegenda.sem': 'Sin registro en la hoja',
    'dp.vale.pendenciaSugerida': 'Sugerido',
    'dp.vale.pendenciaConfirmada': 'Confirmado',
    'dp.vale.pendenciaConfirmar': 'Confirmar pendiente',
    'dp.vale.calculado': 'Calculado {{valor}}',
    'dp.vale.retroativo': 'Mes anterior {{valor}}',
    'dp.vale.ajustado': 'Ajustado',
    'dp.vale.ajustar': 'Ajustar',
    'dp.vale.memoria': 'Cálculo',
    'dp.vale.ajusteTitulo': 'Ajuste de {{nome}}',
    'dp.vale.ajusteValor': 'Valor a pagar',
    'dp.vale.ajusteJustificativa': 'Justificación',
    'dp.vale.ajusteExplica': 'El valor ajustado reemplaza al calculado y sobrevive al recálculo. Déjelo en blanco para volver al calculado.',
    'dp.vale.ajusteSalvar': 'Guardar ajuste',
    'dp.vale.memoriaTitulo': 'Cálculo de {{nome}}',
    'dp.vale.memoria.periodo': 'Período',
    'dp.vale.memoria.vinculo': 'Vínculo en el período',
    'dp.vale.memoria.afastamento': 'Días con licencia',
    'dp.vale.memoria.considerados': 'Días considerados',
    'dp.vale.memoria.conta': 'Cuenta',
    'dp.vale.memoria.fontes': 'Fuentes',
    'dp.vale.memoria.diaria': 'Diaria de Protheus en el período',
    'dp.vale.memoria.gestao': 'Suspensión aplicada en Gestiones',
    'dp.vale.memoria.jornada': 'Gestiones de jornada',
    'dp.vale.memoria.sim': 'Sí',
    'dp.vale.memoria.nao': 'No',
    'dp.vale.corte.ponto_nao_assinado': 'Hoja no firmada',
    'dp.vale.corte.ponto_fora_do_prazo': 'Hoja fuera de plazo',
    'dp.vale.corte.falta_injustificada': 'Falta',
    'dp.vale.corte.suspensao': 'Suspensión',
    'dp.vale.corte.afastamento_acima_do_limite': 'Licencia de más de {{vaZeraAcima}} días',
    'dp.vale.corte.jornada': 'Gestión de jornada',
    'dp.vale.picpay': 'PicPay',
    'dp.vale.picpayDica': 'El archivo de carga de PicPay de cada filial, con quien tiene valor a recibir',
    'dp.vale.semEspelho': 'La hoja de {{espelho}} no está en el Hub, así que nadie fue cortado por la firma. Importe la planilla de control o abra el período en Firma de la hoja de asistencia y recalcule.',
    'dp.vale.assinatura.assinado_no_prazo': 'Firmó en plazo',
    'dp.vale.assinatura.assinado_fora_do_prazo': 'Firmó fuera de plazo',
    'dp.vale.assinatura.pendente': 'No firmó',
    'dp.vale.assinatura.isento': 'Exento',
    'dp.vale.assinatura.sem': 'Sin registro',
    'dp.vale.fonte.ponto_nao_assinado': 'Viene de Firma de la hoja de asistencia',
    'dp.vale.fonte.ponto_fora_do_prazo': 'Viene de Firma de la hoja de asistencia',
    'dp.vale.fonte.falta_injustificada': 'Viene de la diaria de Protheus',
    'dp.vale.fonte.suspensao': 'Viene de la diaria de Protheus o de una Gestión de suspensión aplicada',
    'dp.vale.fonte.afastamento_acima_do_limite': 'Viene de la diaria de Protheus, {{dias}} días con licencia',
    'dp.vale.pendenciaPagar': 'Pagar el pendiente del mes anterior',
    'dp.vale.pendenciaExplica': 'Suma un mes completo, {{valor}}, para quien fue cortado por la firma en el período anterior y firmó después.',
    'dp.vale.pendenciaSugeridaAviso': 'El Hub sugiere el pendiente: la persona fue cortada por la firma en el período anterior y firmó después.',
    'dp.vale.memoria.diasN': '{{n}} días',
    'dp.vale.memoria.limite': 'Se anula por encima de {{n}} días',
    'dp.vale.memoria.espelho': 'Hoja de {{rotulo}}',
    'dp.vale.memoria.cortado': 'Cortado, el mes queda en cero',
    'dp.vale.memoria.retroativo': 'Pendiente del mes anterior',
    'dp.vale.memoria.ajuste': 'Ajuste manual',
    'dp.vale.memoria.final': 'Valor final',
    'dp.vale.memoria.semDiaria': 'Ninguna diaria en el período',
    'dp.vale.memoria.cortes': 'Cortes',
    'dp.vale.admitidoEm': 'Admitido el {{data}}',
    'dp.vale.desligadoEm': 'Desvinculado el {{data}}',
    'dp.vale.kpi.pendenciasDica': '{{confirmadas}} confirmados y {{sugeridas}} sugeridos por el Hub',
    'dp.vale.pessoasN': '{{n}} personas',
  },
}
